// MainMenu.js

import React, { useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/CommonCtx';
import { colorTheme } from '../styles/Theme';
//import FixedHeader from './FixedHeader';
//import FixedBottom from './FixedBottom';
//import { useTheme } from "@emotion/react";
import { styled, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
//import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
//import AppBar from '@mui/material/AppBar';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
//import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
//import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import BottomNavigation from '@mui/material/BottomNavigation';
import bgMain from '../images/bg_main.jpg';

const MainMenu = (props) => {
    //console.log('mainmenu_props', props);

    //const theme = useTheme();
    //const navigate = useNavigate();

    //const [value, setValue] = useState('0');
    //const ref = useRef(null);

    const { ml, setMode, port } = useAuth();
    //console.log('mainmenu_user', user);

    const handleButtonMenu = (e) => {
        //console.log('buttonmenu', e);
        
        let menu = e.target.textContent;
        //console.log('menu', menu);
        //if (menu === ml.SITE_PICTURES) navigate('/sitepics');
        //if (menu === ml.SITE_PICTURES) setMode('SitePics');
        if (menu === ml.PHOTO_REG) setMode('SitePics');
        else if (menu === ml.ISSUE_REG) setMode('IssueReg');
        else if (menu === ml.PANO_360) setMode('Pano360');
        else if (menu === ml.NOTICE_BOARD) setMode('NotiBrd');
    };

    const handlePpms = () => {
        window.location.replace(`https://ppms.mingspm.com:${port}`);
    };
    const handleConfer = () => {
        window.location.replace('https://meet.mingspm.com:9400');
    };

    useEffect(() => {
        // set in FixedBottom
        //setCamera(0);
    }, []);

    const ContainerMain = styled(Container)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        alignItems: 'center',
        //justifyContent: 'center',
        //background: '#f0f8ff',
        background: 'none',
        //background: theme.palette.grey[50],
        position: 'relative',
        zIndex: 1,

        //backgroundImage: `url(${bgMain})`,
        //backgroundRepeat: 'no-repeat',
        //backgroundColor: 'rgba(255, 255, 255, 0.5)', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
        //backgroundSize: 'cover',
        //backgroundPosition: 'center',
    }));
    const BoxBg = styled(Box)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        alignItems: 'center',
        //justifyContent: 'center',
        //background: '#f0f8ff',
        //background: theme.palette.grey[50],

        backgroundImage: `url(${bgMain})`,
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'rgba(255, 255, 255, 0.5)', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'absolute',
        zIndex: -1,
        opacity: .4
    }));
    //const BoxMenu = styled(Box)(({theme}) => ({
    //    display: 'flex',
    //    //flexDirection: 'column',
    //    //flexGrow: 1,
    //    //flexDirection: {
    //    //    xs: 'column', // mobile
    //    //    sm: 'row', // tablet and up
    //    //},
    //    width: '100%',
    //    height: '100%',
    //    alignItems: 'center',
    //    justifyContent: 'center',
    //    borderRadius: 10,
    //    //background: theme.palette.white,
    //    //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    //}));
    const ButtonMenu = styled(Button)(({theme}) => ({
        width: '40%', //'100%',
        height: '10vh',
        borderRadius: 10,
        //fontWeight: 'bold',
        //color: theme.palette.primary.main,
        //background: theme.palette.success.light,
        //background: '#48d1cc', //'#6495ed',
        //background: '#ffffff',
        //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    //const CardMenu = styled(Card)(({theme}) => ({
    //    display: 'flex',
    //    flexDirection: 'column',
    //    flexGrow: 1,
    //    //flexDirection: {
    //    //    xs: 'column', // mobile
    //    //    sm: 'row', // tablet and up
    //    //},
    //    //minWidth: '40%', //'80%',
    //    width: '40%', //'80%',
    //    height: '10vh',
    //    alignItems: 'center',
    //    justifyContent: 'center',
    //    borderRadius: 10,
    //    background: theme.palette.white,
    //    boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    //}));

    return (
        <ThemeProvider theme={colorTheme}>
        <ContainerMain maxWidth={false} disableGutters sx={{ m:0, p:0, width: '100%', flexGrow: 1 }}>
            <BoxBg />
            <Toolbar sx={{ display: 'block', minHeight: '56px' }} />
            {/*
            <Grid container alignItems="center" sx={{ display: 'flex', width: '100%', height: '80%' }}>
                <Grid item xs={12} sm={12} md={12} sx={{ mx: 0 }}>&nbsp;</Grid>
                <Grid item xs={2} sm={2} md={2} sx={{ mx: 0 }}></Grid>
                <Grid item xs={8} sm={8} md={8} sx={{ mx: 0 }}>
                    <BoxMenu sx={{ m: 0 }}>
                        <ButtonMenu type="button" variant="outlined" sx={{ m: 0 }} onClick={handleButtonMenu}>
                            <Typography textAlign="center" variant="subtitle1">
                                {ml.SITE_PICTURES}
                                {ml.SITE_INSPECT}
                                {ml.ISSUE_MGMT}
                                {ml.ASSET_MGMT}
                            </Typography>
                        </ButtonMenu>
                    </BoxMenu>
                </Grid>
                <Grid item xs={2} sm={2} md={2} sx={{ mx: 0 }}></Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mx: 0 }}>&nbsp;</Grid>
                <Grid item xs={12} sm={12} md={12} sx={{ mx: 0 }}>&nbsp;</Grid>
            </Grid>
            */}
            {/*
            <Box sx={{ width: '100%', height: 'calc(100% - 112px)' }}>
            <Box sx={{ width: '100%', "&:before": { content: '""', display: 'inline-block', verticalAlign: 'middle', height: '100%' } }} id="innerbox">
            */}
            <Box sx={{ width: '100%', height: 'calc(100% - 112px)', display: 'table', tableLayout: 'fixed', textAlign: 'center' }}>
            <Box sx={{ width: '100%', display: 'table-cell', verticalAlign: 'middle' }} id="innerbox">
            <Box sx={{ display: 'flex', direction: 'column', flexWrap: 'wrap', height: '1vh' }}> 
            </Box>
            <Box sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap', my: 'auto' }}> 
                <ButtonMenu type="button" variant="outlined" color="secondary" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.ISSUE_REG}
                    </Typography>
                </ButtonMenu>
                <ButtonMenu type="button" variant="outlined" color="primary" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.PHOTO_REG}
                    </Typography>
                </ButtonMenu>
            </Box>
            <Box sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap', my: '10%' }}></Box>
            {/*
            <Box alignItems="center" sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap' }}> 
                <ButtonMenu type="button" variant="outlined" color="success" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.INSPECTION}
                    </Typography>
                </ButtonMenu>
                <ButtonMenu type="button" variant="outlined" color="error" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.SAFETY_INSPECT}
                    </Typography>
                </ButtonMenu>
            </Box>
            */}
            {/*
            <Box alignItems="center" sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap' }}> 
                <ButtonMenu type="button" variant="outlined" color="error" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.TBM}
                    </Typography>
                </ButtonMenu>
                <ButtonMenu type="button" variant="outlined" color="error" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.SAFETY_INSTR}
                    </Typography>
                </ButtonMenu>
            </Box>
            */}
            {/*
            <Box alignItems="center" sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap' }}> 
                <ButtonMenu type="button" variant="outlined" color="warning" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.QUAL_INSPECT} 
                    </Typography>
                </ButtonMenu>
                <ButtonMenu type="button" variant="outlined" color="indigo" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.MATL_MGT}
                    </Typography>
                </ButtonMenu>
            </Box>
            */}
            <Box alignItems="center" sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap' }}> 
                <ButtonMenu type="button" variant="outlined" color="cyan" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.PANO_360}
                    </Typography>
                </ButtonMenu>
                <ButtonMenu type="button" variant="outlined" color="lightGreen" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleButtonMenu}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.NOTICE_BOARD}
                    </Typography>
                </ButtonMenu>
            </Box>
            <Box sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap', my: '10%' }}></Box>
            <Box alignItems="center" sx={{ display: 'flex', direction: 'column', flexWrap: 'nowrap' }}> 
                <ButtonMenu type="button" variant="outlined" color="blueGrey" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handlePpms}>
                    <Typography textAlign="center" variant="subtitle1">
                        {/* <a href="https://ppms.mingspm.com" target="_blank" rel="noopener noreferrer">PPMS</a> */}
                        PPMS
                    </Typography>
                </ButtonMenu>
                <ButtonMenu type="button" variant="outlined" color="teal" sx={{ mt: 1, mb: 1, marginLeft: '5%', marginRight: '5%', borderWidth: 4,
                        bgcolor: 'rgba(255, 255, 255, 0.9)', "&:hover": {borderWidth: 4, background: "rgba(255, 255, 255, 0.9)"} }} onClick={handleConfer}>
                    <Typography textAlign="center" variant="subtitle1">
                        {ml.VIDEO_CONFER}
                    </Typography>
                </ButtonMenu>
            </Box>
            </Box>
            </Box>
            {/*
            <Box alignItems="center" sx={{ display: 'flex', direction: 'column', flexWrap: 'wrap', flexGrow: 1 }}> 
                <CardMenu variant="outlined" sx={{ mt: 2, mb: 2, mx: 4}}>
                    <Box sx={{ width: '100%', height: '100%', display: 'flex' }}>
                    </Box>
                </CardMenu>
                <Box sx={{ display: 'flex', height: 56, width: '100%' }}>&nbsp;</Box>
            </Box>
            */}
            <BottomNavigation value="" sx={{ display: 'block', minHeight: '56px', background: 'none' }} />
        </ContainerMain>
        </ThemeProvider>
    );
};

export default MainMenu;


